// export const BASE_URL = 'https://metagymdev.exbody.com:59881/';
// export const BASE_URL = 'https://dashboard.exbody.qa.metafamily.world/';
// export const BASE_URL = 'https://dashboard.exbody.metafamily.world/';

const DEV_URL = 'https://metagymdev.exbody.com:59881/v1/';
const LIVE_URL = 'https://dashboard.exbody.metafamily.world/v1/';
const QA_URL = 'https://dashboard.exbody.qa.metafamily.world/v1/';

export const BASE_URL = window.location.origin.includes(
  'dashboard.exbody.metafamily.world'
)
  ? LIVE_URL
  : window.location.origin.includes('qa')
    ? QA_URL
    : DEV_URL;
